module.exports = __webpack_public_path__ + "img/Sort.bc23432c.svg";